import { render, staticRenderFns } from "./QuestionTemplateList.vue?vue&type=template&id=d235e49e&scoped=true"
import script from "./QuestionTemplateList.vue?vue&type=script&lang=js"
export * from "./QuestionTemplateList.vue?vue&type=script&lang=js"
import style0 from "./QuestionTemplateList.vue?vue&type=style&index=0&id=d235e49e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d235e49e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
